import type {FileApiModel} from '../../../api/media/file';

import {getFileSrc} from './getFileSrc';

export const getFileName = (file: FileApiModel) => {
  const {filename, title, urlrepr} = getFileSrc(file);

  let result = filename || title;

  if (file.type === 'url' && !result) {
    result = urlrepr.replace(/\?.*$/, '').split('/').filter(Boolean).pop();
  }

  return result;
};
